<template>
  <div class="hello">

    <menupicker value="home"></menupicker>
    <h1>{{ msg }}</h1>
    <div class="center green rcorners1">
      <ul class="normalul">
        <li class="normalli">To perpetuate the common sense use and enjoyment of horses in America’s back country and
          wilderness
        </li>
        <li class="normalli">To work to ensure that public lands remain open to recreational stock use</li>
        <li class="normalli">To assist the various government and private agencies in their maintenance and management
          of said resources
        </li>
        <li class="normalli">To educate, encourage, and solicit active participation in the wise and sustaining use of
          the back country resources by horsemen and the general public commensurate with our heritage
        </li>
      </ul>
    </div>

    <div class="center rcorners1">
      <p class="subinfo">Primary Contact Information</p>
      <p class="subinfo">President - {{ president}} <a :href="emaillink">{{email}}</a></p>
      <p class="subinfo">{{phnumber}}</p>
      <p class="subinfo">{{address1}}</p>
      <p class="subinfo">{{address2}}</p>
      <p class="subinfo"> {{city}}, {{state}} {{zip}}</p>
    </div>
  </div>

</template>

<script>
  import Vue from 'vue';
  import Vuex from 'vuex';
  import Vuetify from 'vuetify';
  import MenuPicker from './MenuPicker.vue';
  import DynamoDb from "aws-sdk/clients/dynamodb";

  Vue.use(Vuetify);
  Vue.use(Vuex);
  Vue.component('menupicker', MenuPicker);

  export default {
    name: 'GmbchMain',
    data() {
      return {
        msg: 'Our Mission',
        president: 'Yancy Melancon',
        phnumber: '337-344-8313',
        address1: 'PO Box 4872',
        address2: '',
        city: 'Grand Junction',
        state: 'Colorado',
        zip: '81502',
        email: 'brushhog@ymail.com',
        emaillink: 'mailto::brushhog@ymail.com'
      }
    },
    methods: {
      loadData(awscredentials) {
        const docClient = new DynamoDb.DocumentClient({
          region: localStorage.getItem('region'),
          credentials: awscredentials,
        });

        const query = {
          TableName: 'contacts-webcontents',
        }
        return new Promise((resolve, reject) => {
          docClient.scan(
            query,
            (error, data) => {
              if (error) {
                console.error('dynamodb error: ' + error.message);
                reject(`dynamodb error: ${error.message}`);
              }
              resolve(data);
            }
          )
        })
      },
      parseData(data) {
        // find and load president info
        for (let i = 0; i < data.Items.length; i++) {
          if (data.Items[i].title === "President") {
            console.log("found president: " + JSON.stringify(data.Items[i]));
            this.president = data.Items[i].name;
            this.email = data.Items[i].email;
            this.emaillink = "mailto::" + data.Items[i].email;
            this.phnumber = data.Items[i].phone;
          }
        }
      },
      initCredentials() {
        const credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: localStorage.getItem('poolid'),
        }, {region: localStorage.getItem('region')});
        return credentials;
      }
    },
    mounted() {
      this.loadData(this.initCredentials())
        .then(data => this.parseData(data));
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
    font-size: large;
  }

  ul .link {
    list-style-type: none;
    padding: 0;
  }

  li .link {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .bodycenter {
   font-family: "Adobe Devanagari";
    font-size: large;
    font-weight: bold;
    width: 100%;
    text-align: left;
  }

  .center {
    margin: auto;
    margin-top: 5px;
    width: 95%;
    padding: 10px;
  }

  .green {
    border: 3px solid green;
  }

  .normalli {
    font-family: "Adobe Devanagari";
    font-size: medium;
    font-weight: bold;
    text-align: left;
    margin-bottom: 1em;
  }

  .rcorners1 {
    border-radius: 25px;
    padding: 5px;
  }

  .subinfo {
    margin: 0;
    font-size: medium;
    font-family: "Adobe Devanagari";
    font-weight: bold;
  }

</style>



// WEBPACK FOOTER //
// src/components/GmbchMain.vue